
import VButton from '~/components/ui/VButton'

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        description() {
            if (this.item.description.length > 200) {
                return `${this.item.description.slice(0, 200)}...`
            }
            return this.item.description
        },
        date() {
            let options = {
                weekday: "short",
                month: "long",
                day: "numeric",
            }
            return new Date(this.item.eventDate).toLocaleDateString(this.$i18n.localeProperties.iso, options)
        },
        price() {
            if (this.item.price === '0' || this.item.price === 0) {
                return this.$t('general.free')
            }
            return this.item.price
        }
    },
    components: {
        VButton
    }
}
